import { HASURA_CLAIMS_KEY } from "constants/auth";
import jwtDecode from "jwt-decode";

export const decodeToken = (token: string): any | null => {
  if (!token) {
    return null;
  }
  try {
    return jwtDecode(token);
  } catch (error) {
    console.error("Error decoding token:", error);
    return null;
  }
};

export const getHasuraClaims = (token: string | null): any | null => {
  if (!token) {
    return null;
  }
  const decoded = decodeToken(token);
  if (!decoded) {
    return null;
  }
  try {
    const claimsString = decoded[HASURA_CLAIMS_KEY];
    if (!claimsString) {
      return null;
    }
    return JSON.parse(claimsString);
  } catch (error) {
    console.error("Error parsing Hasura claims:", error);
    return null;
  }
};
